export default "__VITE_ASSET__Bl4eZY7V__"